"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.withDescription = function (Component) { return function (props) {
    var description = props.description, errorMessage = props.errorMessage, rest = __rest(props, ["description", "errorMessage"]);
    var errorComponent = props.errorComponent || (errorMessage && React.createElement("p", { className: "error p-t-error50 p-m-t-sm" }, errorMessage)) || null;
    return (React.createElement("div", null,
        React.createElement(Component, __assign({}, rest)),
        description && React.createElement("p", { className: "note p-m-t-sm" }, description),
        errorComponent));
}; };
exports.default = exports.withDescription;
//# sourceMappingURL=withDescription.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/hocs/common/withDescription.js
// module id = 911
// module chunks = 0